$(document).ready(function () {
  // Partners logos slider start

  if ($(".js-cwr-parteners-slider").length > 0) {
    $(".js-cwr-parteners-slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      lazyLoad: "progressive",
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: true,
      // slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  }

  // Partners logos slider end



  // Extra Product slider start

  if ($(".js-cwr-product-details-extra-product-slider").length > 0) {
    $(".js-cwr-product-details-extra-product-slider").slick({
      lazyLoad: "progressive",
      slidesToShow: 1.7,
      infinite: false,
      arrows: false,
      dots: true,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1.5,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Extra Product slider end

  // Size guide popup toggle start

  if ($(".js-dog-size-guide-button").length > 0) {
    $(".js-dog-size-guide-button").click(function (event) {
      event.preventDefault();
      $(".js-dog-size-guide-popup").toggleClass("is-active");
    });
  }

  if ($(".js-dog-size-guide-popup-close-btn").length > 0) {
    $(".js-dog-size-guide-popup-close-btn").click(function () {
      $(".js-dog-size-guide-popup").removeClass("is-active");
    });
  }

  // Size guide popup toggle end

  /* scroll to target start */

  // jQuery('.scrollTo').click(function(e) {
  //     e.preventDefault();
  //     var jump = jQuery(this).attr('href');
  //     var new_position = jQuery(jump).offset();
  //     var scroll = 0;
  //     jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
  //         var new_position = jQuery(jump).offset();
  //         jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);

  //     });
  // });

  // $('.scrollTo').on('click',function (e) {
  //     e.preventDefault();
  //     var target = this.hash;
  //     var $target = $(target);
  //     $('html, body').stop().animate({
  //         'scrollTop': $target.offset().top
  //     }, 900, 'swing', function () {
  //         // window.location.hash = target;
  //     });
  // });

  /* scroll to target end */

  // Add class when using safari browser start

  if (
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    $("body").addClass("safari");
  }

  // Add class when using safari browser end

  // You will love video play pouse start

  if ($(".js-cwr-media-content-media-btn").length > 0) {
    var videoStatus = "pause";

    $(".js-cwr-media-content-media-btn").click(function () {
      let video = $(this).siblings("video");
      let videoBtn = $(this);

      if (videoStatus === "pause") {
        video[0].play();
        videoStatus = "play";
        videoBtn.addClass("is-active");
      } else {
        video[0].pause();
        videoStatus = "pause";
        videoBtn.removeClass("is-active");
      }
    });
  }

  // You will love video play pouse end

  // Othes JS start

  if ($(".accordion_faq").length > 0) {
    $(document).on("click", ".accordion_faq", function () {
      $(this).toggleClass("active");
      if ($(this).next(".panel").css("display") == "block") {
        $(this).next(".panel").toggle();
      } else {
        $(this).next(".panel").toggle();
      }
    });
  }

  // Othes JS end

  // Testimonial 2 slider start

  if ($(".js-cwr-testimonial-2-slider").length > 0) {
    $(".js-cwr-testimonial-2-slider").slick({
      lazyLoad: "progressive",
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Testimonial 2 slider end

  // matchHeight
  // if ($(".card .content .title").length > 0) {
  //   $(".card .content .title").matchHeight({
  //     byRow: 0,
  //   });
  // }
  // if ($(".card .content .loox-rating").length > 0) {
  //   $(".card .content .loox-rating").matchHeight({
  //     byRow: 0,
  //   });
  // }
  // if ($(".card .content .price1").length > 0) {
  //   $(".card .content .price1").matchHeight({
  //     byRow: 0,
  //   });
  // }
  // if ($(".card .content .price2").length > 0) {
  //   $(".card .content .price2").matchHeight({
  //     byRow: 0,
  //   });
  // }
  // end matchHeight

  // match height of cards on search page
  let searchCard = setInterval(function () {
    if ($(".grid .column img").length > 0) {
      $(".grid .column img").matchHeight({
        byRow: 1,
        property: "min-height",
      });
    }

    if ($(".grid .column h4").length > 0) {
      $(".grid .column h4").matchHeight({
        byRow: 1,
      });
    }

    if ($(".grid .column .rte p").length > 0) {
      $(".grid .column .rte p").matchHeight({
        byRow: 1,
      });
    }
    if ($(".grid .column .feature-link").length > 0) {
      $(".grid .column .feature-link").matchHeight({
        byRow: 1,
      });
    }
  }, 1000);

  setTimeout(function () {
    clearInterval(searchCard);
  }, 5000);
  // end

  // match height for custom blog temlate grid
  if ($("#myTabContent .content .title").length > 0) {
    $("#myTabContent .content .title").matchHeight({
      byRow: 1,
    });
  }

  if ($("#myTabContent .content span").length > 0) {
    $("#myTabContent .content span").matchHeight({
      byRow: 1,
    });
  }
  if ($("#myTabContent .content .custom-article-content").length > 0) {
    $("#myTabContent .content .custom-article-content").matchHeight({
      byRow: 1,
    });
  }

  if ($("#myTabContent .content .btn-solid-reg").length > 0) {
    $("#myTabContent .content .btn-solid-reg").matchHeight({
      byRow: 1,
    });
  }

   // Close Popup

   $('.close_fact_popup_img a').on('click', function(e){
    e.preventDefault();
    $('.cwr_facs_wrapper.offer_page').hide();
    $('body').removeClass('overflow-hidden');
  });

  $('.cwr-product-fact a').on('click', function(e){
    e.preventDefault();
    $('.cwr_facs_wrapper.offer_page').show();
    $('body').addClass('overflow-hidden');
  });

  // Recomandation Slider
  setTimeout(function () {
    if ($(".product-slider-bg.pdp_new_temp").length > 0) {
      $(".product-slider-bg.pdp_new_temp .like-product .row").slick({
        dots: false,
        arrows: true,
        infinite: false,
        lazyLoad: "progressive",
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    }
  }, 5000);

  mobileOnlySlider(".usp-slider", false, false, true, 2000, 991);

  function mobileOnlySlider($slidername, $dots, $arrows,  $autoplay, $autoplaySpeed, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      dots: $dots,
      arrows: $arrows,
      autoplay: $autoplay,
      autoplaySpeed: $autoplaySpeed,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };

    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } // Mobile Only Slider
  

  // if product has variant
  if($('.selector-wrapper #option-size').length){
    $('.selector-wrapper #option-size').on('change', function(){
      var get_title = $(this).val();
      $('.product-form .original-selector option').each(function(ie,em){
          var get_title_1 = $(em).text();
          if(get_title_1 == get_title){
              $(em).attr('selected', 'selected');
              var get_price = $(em).attr('data-price');
              var get_com_price = $(em).attr('data-comp-price'); 
              if($('.custom_onetime.product_one_subs').hasClass('Active-Tab')){
                $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price h4').text(get_price);
                if (get_com_price) {  
                  $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price').removeClass('d-none');
                  $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price del').text(get_com_price);

                }else{
                  $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price').addClass('d-none');
                }
              }else{
                var get_selling_price = $(em).attr('data-selling-price');
                $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').text(get_selling_price);
              }
          }else{
            $(em).removeAttr('selected');
          }
      });
    });
  }

  $('.product_one_subs').on('click', function(){
    if($('.custom_onetime').length){
      if($(this).hasClass('custom_onetime')){
          var get_price = $('.product-form .original-selector option:selected').attr('data-price');
          var get_com_price = $('.product-form .original-selector option:selected').attr('data-comp-price'); 
          $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price h4').text(get_price);
          $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price del').text(get_com_price);
      
      }else{
          var get_selling_price = $('.product-form .original-selector option:selected').attr('data-selling-price');
          if (get_selling_price) {  
            $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').removeClass('d-none');  
            $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').text(get_selling_price);     
          }else{
            $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').addClass('d-none');  
          }
      }
    }
  });


  // Fix alignment issue of ingredients_details_wrap on lp
  $('#landing-2 .ingredients_details_wrap,#landing-product .ingredients_details_wrap,#new-landing .ingredients_details_wrap').each(function() {
    if ($(this).find('h2').text().trim() === "Lion's Mane") {
        let paragraph = $(this).find('p');
        let currentText = paragraph.html();

        // Option 1: Add a space at the end of the text
        paragraph.html(currentText + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

        // Option 2: Add a non-breaking space (optional if you want it to be non-breaking)
        // paragraph.html(paragraph.html() + '&nbsp;');
    }
  });
});

  // Product details slider start

    function initProductGallery() {
  // swiper code

      const thumbsEl = document.querySelector(".js-cwr-product-details-nav-slider");
      const mainEl = document.querySelector(".js-cwr-product-details-main-slider");

      if (!thumbsEl || !mainEl) return;

      const thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 5,
        spaceBetween: 0,
        freeMode: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slideToClickedSlide: true,
        observer: true,
        observeParents: true,

        breakpoints: {
          0: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 5,
          }
        }
      });

      const mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        speed: 500,
        observer: true,
        observeParents: true,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        thumbs: {
          swiper: thumbsSwiper,
        },
      });

}

document.addEventListener('DOMContentLoaded', initProductGallery);

document.addEventListener('shopify:section:load', initProductGallery);

  // Product details slider start

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("input.quantity").forEach(function (ele) {
    ele.addEventListener("change", function () {
      isSetValue(ele);
    });
  });

  function isSetValue(ele) {
    if (
      ele.value == "" ||
      ele.value == " " ||
      ele.value == "0" ||
      ele.value == "00"
    ) {
      ele.value = 1;
    }
  }
});

setTimeout(function(){

console.log('is load');

  // Update rewardbar message
  function checkSubscription(items) {
    let hasSubscription = false;
    items.map((item) => {
      if (item.selling_plan_allocation) {
      hasSubscription = true;
      }
    });

    const rewardBar = window.upcartDocumentOrShadowRoot.querySelector(".upcart-rewards-message p"); // Adjust selector as needed
    const rewardBar_color = window.upcartDocumentOrShadowRoot.querySelector(".upcart-rewards-bar-background"); // Adjust selector as needed
      const rewardBar_icon = window.upcartDocumentOrShadowRoot.querySelector(".styles_TieredRewards__tiersContainer__"); // Adjust selector as needed
    if (hasSubscription) {
        console.log('is change');      
        if (rewardBar) {      
          rewardBar.textContent = "🎉 Congrats - You Unlocked Free Shipping! 🎉";        
          rewardBar_color.classList.add("hide");
          rewardBar_icon.classList.add("hide");
        }
    }else{
        rewardBar_color.classList.remove("hide");
        rewardBar_icon.classList.remove("hide");
    }
  }

 // async Function packag-protection product remove // PACKAGE_PROTECTION
  async function handleProtectionRemoval() {
    console.log('--- PROTECTION CHECK START ---');

    const TARGET_PRODUCT_ID = 9201297948922;

    const cart = await fetch('/cart.js').then(res => res.json());

    if (cart.attributes?.package_protection !== "true") {
      console.log('Attribute not true → skip');
      return;
    }

    const updates = {};

    cart.items.forEach(item => {
      if (item.product_id == TARGET_PRODUCT_ID) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      console.log('Protection removed ✅');
    }

    // clear attribute (VERY IMPORTANT)
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { package_protection: "" }
      })
    });

    // 🔥 GET FINAL CART + SYNC BUBBLE
    const updatedCart = await fetch('/cart.js').then(res => res.json());
    updateCartBubble(updatedCart.item_count);

    if (window.upcartRefreshCart) {
      window.upcartRefreshCart();
    }

    console.log('--- PROTECTION CHECK END ---');
  }

 // Update CartBubble // PACKAGE_PROTECTION
  function updateCartBubble(count) {
    const bubble = document.querySelector('.cart__count');

    if (!bubble) return;

    bubble.textContent = count;
  }

  window.upcartModifyCart = (cart) => {
    // ✅ INSTANT UI FIX (no flicker) // PACKAGE_PROTECTION
      cart.items = cart.items.filter(item => {
        if (
          cart.attributes?.package_protection === "true" &&
          item.product_id == 9201297948922
        ) {
          return false; // remove from UI instantly
        }
        return true;
      });

      // 🔥 UPDATE BUBBLE INSTANTLY
      const newCount = cart.items.reduce((total, item) => total + item.quantity, 0);
      updateCartBubble(newCount);// since 1 item removed

      setTimeout(() => {
        handleProtectionRemoval();
      }, 0);
    setTimeout(() => {
      
      // let upsellWidget = window.upcartDocumentOrShadowRoot.querySelector('#up-upsell-carousel');
      // upsellWidget.style.display = 'none';
      // upsellWidget.classList.add("hide");   
      refreshcart(cart.items) ;
      checkSubscription(cart.items);
      updateProtectionUI();
    }, 500);
    return cart;
  };


// Remove from cart // PACKAGE_PROTECTION
window.upcartOnItemRemoved = async (_, removedItem) => {
  const removedItemVariantId = removedItem.variant_id;
  const isLandingPage = removedItem.properties?._islandingpage;

  // Only proceed if removed item has `_islandingpage`
  if (!isLandingPage) return;

  // Fetch current cart
  const res = await fetch('/cart.js');
  const cart = await res.json();

  for (const cartItem of cart.items) {
    // Skip the removed item itself
    if (cartItem.key === removedItem.key) continue;

    const freeProduct = cartItem.properties?._free_product;
    const mainProduct = cartItem.properties?._main_product;

    // Check if item has both _free_product and _main_product
    if (freeProduct && mainProduct) {
      // Check if mainProduct contains the removed item's variant ID
      const mainProductIds = mainProduct.split(','); // assuming CSV
      if (mainProductIds.includes(removedItemVariantId.toString())) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cartItem.key, quantity: 0 })
        });
        console.log('Removed linked item:', cartItem.title);
      }
    }
  }

  // Refresh cart after changes
  window.upcartRefreshCart();
  updateProtectionUI();
};

// refreshcart Start 
  function refreshcart(items){    
      console.log('refresh cart');
      const upCartDiv = document.getElementById('upCart');
      if (upCartDiv && upCartDiv.shadowRoot) {
        const itemElements = upCartDiv.shadowRoot.querySelectorAll('.styles_ProductRow__product__');
          items.forEach((item, index) => {
          if (!itemElements[index]) return;
          const hasSpecialProperty = Object.keys(item.properties).some(key => key.includes('_islandingpage'));
          if (hasSpecialProperty) {
            const updatetext = itemElements[index].querySelector('.upcart-item-option-value');
            if (updatetext) {
              const textValue = updatetext.textContent.trim();
              if (textValue === 'Buy 3 Jars') {
                updatetext.textContent = textValue + ' + Get 2 FREE Gifts!';
              }else if(textValue === 'Buy 2 Jars'){
                updatetext.textContent = textValue + ' + 1 Free Omega Love +';
              }
            }
          }
        });
      }
  };

  // open cart-drawer js
  window.upcartOnCartOpened = function () {
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        const upCartDiv = document.getElementById('upCart');
      
        if (upCartDiv && upCartDiv.shadowRoot) {
            const itemElements = upCartDiv.shadowRoot.querySelectorAll('.styles_ProductRow__product__');
            data.items.forEach((item, index) => {
              if (!itemElements[index]) return;

              // Check for _free_product key to hide the element
              const isFreeProduct = Object.keys(item.properties).some(key => key.includes('_free_product'));
              if (isFreeProduct) {
                const hide_subscirbebutton = itemElements[index].querySelector('.SubscriptionUpgradesModule_section__');
                if (hide_subscirbebutton) {
                  hide_subscirbebutton.style.display = 'none';
                }
                
                const quantityField = itemElements[index].querySelector('.styles_QuantityField__');
                if (quantityField) {
                  quantityField.style.display = 'none';
                }
              }
              


              const hasSpecialProperty = Object.keys(item.properties).some(key => key.includes('_islandingpage'));
              if (hasSpecialProperty) {
                const updatetext = itemElements[index].querySelector('.upcart-item-option-value');
                if (updatetext) {
                  const textValue = updatetext.textContent.trim();
                  if (textValue === 'Buy 3 Jars') {
                    updatetext.textContent = textValue + ' + Get 2 FREE Gifts!';
                  }else if(textValue === 'Buy 2 Jars'){
                    updatetext.textContent = textValue + ' + 1 Free Omega Love +';
                  }
                }
                

                // const removeBtn = itemElements[index].querySelector('.styles_TrashButton__deleteButton__');
                // if (removeBtn) {
                //   removeBtn.style.display = 'none';
                // }
              }        
            });
        } else {
            console.log('Shadow DOM host element not found or no shadowRoot attached.');
        }
      }).catch(err => console.error('Cart fetch failed:', err));
      console.log('cart is updated;')   
      updateProtectionUI();
  };

  // Hide cart drawer
  function hideRewards() {
    const root = window.upcartDocumentOrShadowRoot;
    if (!root) return; // Exit if root not ready

    let rewardsBar = root.querySelector(".upcart-rewards");
    // rewardsBar?.classList.add("hide");

    let addOn = root.querySelector(".styles_AddonsModule__.upcart-addons");
    if (addOn) {  // ✅ null check
      addOn.style.display = 'none';
      addOn.classList.add("hide");
    }

    let upsellWidget = root.querySelector('#up-upsell-carousel');
    if (upsellWidget) {  // ✅ null check
      upsellWidget.style.display = 'none';
      upsellWidget.classList.add("hide");
    }
  }

  window.upcartOnCartOpened = setTimeout(hideRewards, 300);
  window.upcartOnCartLoaded = hideRewards;
  // Hide cart drawer End

},1000);



  // matchHeight moved outside, runs after full page load
  $(window).on("load", function () {
    $(".card .content .title").matchHeight({ byRow: 0 });
    $(".card .content .loox-rating").matchHeight({ byRow: 0 });
    $(".card .content .price1").matchHeight({ byRow: 0 });
    $(".card .content .price2").matchHeight({ byRow: 0 });

    // Force recalculate after a short delay (catches font/image late renders)
    setTimeout(function () {
      $.fn.matchHeight._update();
    }, 500);
  });


  // Package Protection Code Started  // PACKAGE_PROTECTION

  function updateProtectionUI() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const currency = Shopify.currency.active;
        const rate = Shopify.currency.rate || 1;

        // Step 1: Get original subtotal (WITHOUT discount)
        let originalSubtotal = cart.original_total_price / 100;

        // Step 2: Apply discount to get discounted subtotal
        let discount = (cart.total_discount || 0) / 100;
        let discountedSubtotal = originalSubtotal - discount;

        // Step 3: Convert discounted subtotal to USD for tier selection
        let discountedSubtotalUSD = currency !== 'USD' ? discountedSubtotal / rate : discountedSubtotal;

        // Step 4: Pick protection tier based on DISCOUNTED subtotal in USD
        let protectionVariant = null;
        let protectionPriceUSD = 0;

        if      (discountedSubtotalUSD <= 74.99)  { protectionVariant = 48729471353082; protectionPriceUSD = 1.67;  }
        else if (discountedSubtotalUSD <= 109.99) { protectionVariant = 48729471385850; protectionPriceUSD = 2.97;  }
        else if (discountedSubtotalUSD <= 199.99) { protectionVariant = 48729471418618; protectionPriceUSD = 4.47;  }
        else if (discountedSubtotalUSD <= 249.99) { protectionVariant = 48729471451386; protectionPriceUSD = 5.97;  }
        else if (discountedSubtotalUSD <= 299.99) { protectionVariant = 48729471484154; protectionPriceUSD = 7.97;  }
        else if (discountedSubtotalUSD <= 349.99) { protectionVariant = 48729471516922; protectionPriceUSD = 9.47;  }
        else if (discountedSubtotalUSD <= 399.99) { protectionVariant = 48729471549690; protectionPriceUSD = 11.47; }
        else if (discountedSubtotalUSD <= 449.99) { protectionVariant = 48729471582458; protectionPriceUSD = 12.97; }
        else if (discountedSubtotalUSD <= 499.99) { protectionVariant = 48729471615226; protectionPriceUSD = 14.97; }
        else if (discountedSubtotalUSD <= 549.99) { protectionVariant = 48729471647994; protectionPriceUSD = 16.47; }
        else if (discountedSubtotalUSD <= 599.99) { protectionVariant = 48729471680762; protectionPriceUSD = 18.47; }
        else if (discountedSubtotalUSD <= 649.99) { protectionVariant = 48729471713530; protectionPriceUSD = 19.97; }
        else if (discountedSubtotalUSD <= 699.99) { protectionVariant = 48729471746298; protectionPriceUSD = 21.97; }
        else if (discountedSubtotalUSD <= 749.99) { protectionVariant = 48729471779066; protectionPriceUSD = 23.47; }
        else if (discountedSubtotalUSD <= 799.99) { protectionVariant = 48729471811834; protectionPriceUSD = 25.47; }
        else if (discountedSubtotalUSD <= 849.99) { protectionVariant = 48729471844602; protectionPriceUSD = 26.97; }
        else if (discountedSubtotalUSD <= 899.99) { protectionVariant = 48729471877370; protectionPriceUSD = 28.97; }
        else if (discountedSubtotalUSD <= 949.99) { protectionVariant = 48729471910138; protectionPriceUSD = 30.47; }
        else if (discountedSubtotalUSD <= 999.99) { protectionVariant = 48729471942906; protectionPriceUSD = 32.47; }
        else                                      { protectionVariant = 48729471975674; protectionPriceUSD = 33.97; }

        // Step 5: Convert protection price to active currency
        let protectionPrice = currency !== 'USD' ? protectionPriceUSD * rate : protectionPriceUSD;

        // Step 6: original subtotal (no discount) + protection price
        let combinedTotal = originalSubtotal + protectionPrice;

        // Step 7: Apply actual discount on combined total
        let finalTotal = combinedTotal - discount;

        console.log('originalSubtotal   -- ' + originalSubtotal);
        console.log('discount           -- ' + discount);
        console.log('discountedSubtotal -- ' + discountedSubtotal);
        console.log('protectionPrice    -- ' + protectionPrice);
        console.log('combinedTotal      -- ' + combinedTotal);
        console.log('finalTotal         -- ' + finalTotal);

        // ✅ Shadow root
        const upCartDiv = document.getElementById('upCart');
        if (!upCartDiv || !upCartDiv.shadowRoot) {
          console.log('❌ Shadow root not found');
          return;
        }

        const root = upCartDiv.shadowRoot;

        // Update protection price
        let priceEl = root.querySelector('.package_protecion_wrapper .price');
        if (priceEl) {
          priceEl.innerHTML = '$' + protectionPrice.toFixed(2);
        }

        // Update total with protection
        let totalEl = root.querySelector('.price_with_protection');
        if (totalEl) {
          totalEl.innerHTML = '$' + finalTotal.toFixed(2);
        }

        // ✅ Button — WITH protection
        let btn = root.querySelector('.checkout-protection');
        if (btn) {
          btn.onclick = function () {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { package_protection: 'true' }
              })
            }).then(() => {
              window.location.href = '/checkout';
            });
          };
        }

        // ✅ Button — WITHOUT protection
        let btn_link = root.querySelector('.checkout_link');
        if (btn_link) {
          btn_link.onclick = function (e) {
            e.preventDefault();
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { package_protection: 'false' }
              })
            }).then(() => {
              window.location.href = '/checkout';
            });
          };
        }

      });
  }

  // PACKAGE_PROTECTION 
  function savedbyInit() {

    const upCartDiv = document.getElementById("upCart");
    // wait until UpCart + shadowRoot exist
    if (!upCartDiv || !upCartDiv.shadowRoot) {
      setTimeout(savedbyInit, 300);
      return;
    }
    const root = upCartDiv.shadowRoot;

    // extra safety check (VERY IMPORTANT)
    if (!root) {
      setTimeout(savedbyInit, 300);
      return;
    }

    // prevent duplicate binding safely
    if (root.savedbyInitDone) return;
    root.savedbyInitDone = true;

    root.addEventListener("click", function (e) {

      const btn = e.target.closest(".pp_help_button");

      if (!btn) return;

      const modal = document.getElementById("savedby-modal");

      if (modal) modal.style.display = "flex";
    });
    console.log("✅ savedbyInit working safely");
  }

  // start // PACKAGE_PROTECTION
  savedbyInit();

  document.addEventListener("click", function (e) {
    // close button click
    if (e.target.closest(".sb-close")) {
      const modal = document.getElementById("savedby-modal");
      if (modal) modal.style.display = "none";
    }
    // click outside modal (background close)
    const modal = document.getElementById("savedby-modal");
    if (modal && e.target === modal) {
      modal.style.display = "none";
    }
  });

// media gallery pop-up JS for PDP page
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('gallery-popup');
  const closeBtn = document.querySelector('.gallery-popup-close');
  const popupSwiper = new Swiper('.gallery-popup-swiper', {
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  // Main gallery click
  document.addEventListener('click', function (e) {
    const image = e.target.closest('.popup-trigger');
    if (!image) return;
    const currentIndex = parseInt(
      image.dataset.slideIndex || 0
    );
    popup.classList.add('active');
    document.body.classList.add('popup-open');
    // Important
    popupSwiper.update();
    setTimeout(() => {
      popupSwiper.slideTo(currentIndex, 0);
    }, 50);
  });

  // Close button
  closeBtn.addEventListener('click', function () {
    popup.classList.remove('active');
    document.body.classList.remove('popup-open');
  });

  // Outside click close
  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      popup.classList.remove('active');
      document.body.classList.remove('popup-open');

    }
  });
});